import { httpV2 } from "@/api";

/**
 * @summary Solicita todos os fabricantes de turbina.
 * @returns Conjunto de fabricante.
 */
const GetManufacturers = function()
{
	return httpV2.get("KnowledgeBase/TurbineManufacturers");
};

/**
 * @summary Solicita os modelos de turbinas de um fabricante.
 * @param {number} turbineManufacturerId Id do fabricante.
 * @returns Conjunto de modelos de turbina do fabricante.
 */
const GetModels = function(turbineManufacturerId)
{
	return httpV2.get(`KnowledgeBase/TurbineManufacturers/${turbineManufacturerId}/Models`);
};

/**
 * @summary Solicita as propriedades de um modelos de turbinas.
 * @param {number} turbineModelId Id do modelo de turbina.
 * @returns Propriedades de um modelo de turbina.
 */
const GetProperty = async function(turbineModelId)
{
	return httpV2.get(`KnowledgeBase/TurbineModels/${turbineModelId}/Property`);
};

/**
 * @summary Solicita as configurações de gerador de um modelo de turbinas.
 * @param {number} turbineModelId Id do modelo de turbina.
 * @returns Configurações de um gerador de um modelo de turbina.
 */
const GetGenerators = async function(turbineModelId)
{
	return httpV2.get(`KnowledgeBase/TurbineModels/${turbineModelId}/Generators`);
};

/**
 * @summary Solicita as configurações de mancais principais de uma turbina.
 * @param {number} turbineModelId Id do modelo de turbina.
 * @returns Configurações de mancais principais de um modelo de turbina.
 */
const GetMainBearings = async function(turbineModelId)
{
	return httpV2.get(`KnowledgeBase/TurbineModels/${turbineModelId}/MainBearings`);
};

export default {
	GetManufacturers,
	GetModels,
	GetProperty,
	GetGenerators,
	GetMainBearings
};